(function($, global, GsBase) {

	/* Snb */
	var $menu = $("#snb>ul");
	var menuHeight = $menu.outerHeight();
	var tvMainCheck = $('#isMain').length;


	// tv 쇼핑 메인 페이지 외
	if ( tvMainCheck == 0 )
		{
		$("#snb").on('mouseenter', function(){
		$(this).addClass('on');
			$menu.one('mouseenter', function(){
				$menu.children('li').each(rePosition);
			});
		}).on('mouseleave', function(){
			$(this).removeClass('on');
		});
	}

	$menu.menuAim({
		activate : activateSubmenu,
		deactivate : deactivateSubmenu,
		exitMenu : function(){
			return true; 
		}
	}).children('li').each(rePosition);

	
	function rePosition() {

		var $this = $(this);
		var $subMenu = $this.find('ul');
		var idx = $this.index();
		var basicSize = $this.height();
		var outerSize = $this.outerHeight(true);
		var subMenuHeight = $subMenu.outerHeight(true);
		var cals = menuHeight - (idx*outerSize);
		var cals2 = (idx+1)*outerSize;
		
		if (subMenuHeight > menuHeight){
			// 서브 메뉴가 메인 메뉴 레이어 높이다 클 경우 
			$subMenu.css({top:-idx * outerSize}); 
		}else {
			if(cals < subMenuHeight ) {
				$subMenu.css({top:'auto',bottom:-(menuHeight-(idx+1)*outerSize)+3});
			}else if(cals2< subMenuHeight){
				$subMenu.css({top:-idx * outerSize});
			}
		}
	}

	function activateSubmenu(row) {
		var $this = $(row);
		rePosition();
		$this.addClass('on');
	}

	function deactivateSubmenu(row) {
		var $this = $(row);
		$this.removeClass('on');
	}
	
	$(document).on('click', function(){
		$menu.find('on').removeClass('on');
	});
}) (jQuery, window, window.GsBase = window.GsBase || {});


